import type * as React from 'react';

function SvgUsaFlag(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" viewBox="0 0 32 32" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="nonzero">
        <circle cx={16} cy={16} fill="#F0F0F0" r={16} />
        <g fill="#D80027">
          <path d="M15.304 16H32c0-1.444-.192-2.843-.551-4.174H15.304V16zM15.304 7.652h14.348a16.084 16.084 0 00-3.692-4.174H15.304v4.174zM16 32c3.766 0 7.227-1.302 9.96-3.478H6.04A15.931 15.931 0 0016 32zM2.348 24.348h27.304a15.905 15.905 0 001.797-4.174H.55a15.905 15.905 0 001.797 4.174z" />
        </g>
        <path
          d="M7.412 2.499H8.87l-1.357.985.518 1.594-1.356-.985-1.356.985.447-1.377A16.088 16.088 0 002.663 7.16h.467l-.863.627c-.134.224-.263.452-.387.683l.412 1.27-.769-.56c-.191.405-.366.82-.523 1.242l.454 1.398H3.13l-1.356.986.518 1.594-1.356-.985-.812.59C.042 14.659 0 15.325 0 16h16V0c-3.16 0-6.107.917-8.588 2.499zm.62 11.901l-1.357-.985-1.356.985.518-1.594-1.356-.986h1.676l.518-1.594.518 1.594H8.87l-1.357.986.518 1.594zm-.519-6.255l.518 1.594-1.356-.985-1.356.985.518-1.594-1.356-.985h1.676l.518-1.595.518 1.595H8.87l-1.357.985zm6.258 6.255l-1.357-.985-1.356.985.518-1.594-1.356-.986h1.676l.518-1.594.518 1.594h1.677l-1.357.986.518 1.594zm-.519-6.255l.518 1.594-1.356-.985-1.356.985.518-1.594-1.356-.985h1.676l.518-1.595.518 1.595h1.677l-1.357.985zm0-4.661l.518 1.594-1.356-.985-1.356.985.518-1.594-1.356-.985h1.676l.518-1.595.518 1.595h1.677l-1.357.985z"
          fill="#0052B4"
        />
      </g>
    </svg>
  );
}

export default SvgUsaFlag;
